import React from 'react';
import { FormattedMessage } from 'react-intl-next';
import Spinner from '@atlaskit/spinner';
import { StyledBox, StyledText } from '../../../../common/ui/picker/styled';
import messages from './messages';
export var LoadingMessage = function LoadingMessage() {
  return /*#__PURE__*/React.createElement(StyledBox, null, /*#__PURE__*/React.createElement(StyledBox, {
    height: 72
  }, /*#__PURE__*/React.createElement(Spinner, {
    size: "large"
  })), /*#__PURE__*/React.createElement(StyledText, null, /*#__PURE__*/React.createElement(FormattedMessage, messages.loadingMessage)));
};